import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { TranslateConfigService } from '../_services/translate-config.service';

@Injectable()
export class LangInterceptor implements HttpInterceptor {

    constructor(private translateConfig: TranslateConfigService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const lang = this.translateConfig.currentLang.value;
        const langHeader = (typeof lang === 'string' && lang) ? lang : 'es';

        request = request.clone({
            setHeaders: {
                'x-lang': langHeader
            }
        });

        return next.handle(request);
    }
}
